




// // Banner.js
// import React, { useState, useEffect } from 'react';
// import { collection, query, where, getDocs } from 'firebase/firestore';
// import { useNavigate } from 'react-router-dom';
// import { db } from '../../firebase/firebaseConfig';
// import './Banner.css';

// const Banner = () => {
//   const [banners, setBanners] = useState([]);
//   const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
//   const [isVisible, setIsVisible] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   // Fetch active banners from Firestore
//   useEffect(() => {
//     const fetchBanners = async () => {
//       try {
//         const simpleQuery = query(
//           collection(db, 'banners'),
//           where('active', '==', true)
//         );

//         const querySnapshot = await getDocs(simpleQuery);

//         if (querySnapshot.empty) {
//           setBanners([]);
//           setLoading(false);
//           return;
//         }

//         // Get all active banners
//         const activeBanners = [];

//         querySnapshot.forEach((doc) => {
//           activeBanners.push({
//             id: doc.id,
//             ...doc.data()
//           });
//         });

//         // Sort by createdAt field (descending order)
//         activeBanners.sort((a, b) => {
//           const dateA = a.createdAt ? new Date(a.createdAt.seconds * 1000) : new Date(0);
//           const dateB = b.createdAt ? new Date(b.createdAt.seconds * 1000) : new Date(0);
//           return dateB - dateA;
//         });

//         setBanners(activeBanners);
//         setLoading(false);
//       } catch (err) {
//         // Try fallback query if first attempt fails
//         try {
//           const allBannersQuery = query(collection(db, 'banners'));
//           const allBannersSnapshot = await getDocs(allBannersQuery);

//           if (allBannersSnapshot.empty) {
//             setBanners([]);
//             setLoading(false);
//             return;
//           }

//           // Filter active banners manually
//           const activeBanners = [];

//           allBannersSnapshot.forEach((doc) => {
//             const data = doc.data();
//             if (data.active === true) {
//               activeBanners.push({
//                 id: doc.id,
//                 ...data
//               });
//             }
//           });

//           // Sort by createdAt field (descending order)
//           activeBanners.sort((a, b) => {
//             const dateA = a.createdAt ? new Date(a.createdAt.seconds * 1000) : new Date(0);
//             const dateB = b.createdAt ? new Date(b.createdAt.seconds * 1000) : new Date(0);
//             return dateB - dateA;
//           });

//           setBanners(activeBanners);
//           setLoading(false);
//         } catch (fallbackErr) {
//           setError(fallbackErr);
//           setLoading(false);
//         }
//       }
//     };

//     fetchBanners();
//   }, []);

//   // Animate banner on mount
//   useEffect(() => {
//     setTimeout(() => setIsVisible(true), 100);
//   }, []);

//   // Auto-rotate banners every 5 seconds
//   useEffect(() => {
//     if (banners.length <= 1) return;

//     const intervalId = setInterval(() => {
//       setCurrentBannerIndex((prevIndex) =>
//         prevIndex === banners.length - 1 ? 0 : prevIndex + 1
//       );
//     }, 5000);

//     return () => clearInterval(intervalId);
//   }, [banners.length]);

//   // Navigation handlers
//   const handleShopNow = () => {
//     navigate('/products');
//   };

//   const handleComponentsHub = () => {
//     navigate('/products');
//   };

//   const handleDesignMakersHub = () => {
//     navigate('/design-makers-hub');
//   };

//   // Banner carousel navigation
//   const goToPrevBanner = () => {
//     setCurrentBannerIndex((prevIndex) =>
//       prevIndex === 0 ? banners.length - 1 : prevIndex - 1
//     );
//   };

//   const goToNextBanner = () => {
//     setCurrentBannerIndex((prevIndex) =>
//       prevIndex === banners.length - 1 ? 0 : prevIndex + 1
//     );
//   };

//   const goToBanner = (index) => {
//     setCurrentBannerIndex(index);
//   };

//   // Loading state
//   if (loading) {
//     return <div className="banner-loading">Loading...</div>;
//   }

//   // Error state
//   if (error) {
//     return <div className="banner-error">Error loading banner. Please refresh the page.</div>;
//   }

//   // No active banners
//   if (!banners.length) {
//     return null;
//   }

//   // Get current banner
//   const currentBanner = banners[currentBannerIndex] || {};

//   // Destructure banner data with defaults
//   const {
//     title = 'One Stop Solution for All Electronic Components',
//     highlightText = 'Electronic Components',
//     description = 'Discover cutting-edge Arduino boards, sensors, components and development tools.',
//     imageUrl = '/images/banner.png',
//     features = [
//       { icon: '⚡', text: 'Genuine Products' },
//       { icon: '🚚', text: 'Fast Delivery' },
//       { icon: '⭐', text: 'Expert Support' }
//     ],
//     badge = {
//       icon: '⚡',
//       text: 'Premium Components'
//     },
//     primaryButtonText = 'Shop Now',
//     secondaryButtonText = 'Watch Demo',
//     floatingCards = [
//       { icon: '🔧', text: 'Arduino & IoT' },
//       { icon: '⚡', text: 'Smart Sensors' }
//     ]
//   } = currentBanner;

//   // Create title with highlighted text
//   const renderTitle = () => {
//     if (!highlightText || !title.includes(highlightText)) {
//       return <>{title}</>;
//     }

//     const parts = title.split(highlightText);
//     return (
//       <>
//         {parts[0]}
//         <span className="highlight">{highlightText}</span>
//         {parts.length > 1 ? parts[1] : ''}
//       </>
//     );
//   };

//   return (
//     <>
//       <section className="banner-section">
//         <div className="banner-container">
//           <div className="banner-header">
//             <div className="banner-badge">
//               <span className="badge-icon">{badge.icon}</span>
//               <span>{badge.text}</span>
//             </div>

//             <div className="urgent-delivery-badge">
//               <span className="urgent-icon">🔔</span>
//               <span>Need it urgently? Call for same-day delivery</span>
//             </div>
//           </div>

//           <div className="banner-content">
//             {/* Left Content */}
//             <div className={`banner-text ${isVisible ? 'animate-in' : ''}`}>
//               <h1 className="banner-title">{renderTitle()}</h1>

//               <div className="banner-features">
//                 {features.map((feature, index) => (
//                   <div className="feature-item" key={index}>
//                     <div className="feature-icon">
//                       {typeof feature.icon === 'string' && feature.icon.includes('<svg') ? (
//                         <span dangerouslySetInnerHTML={{ __html: feature.icon }} />
//                       ) : (
//                         <span>{feature.icon}</span>
//                       )}
//                     </div>
//                     <span>{feature.text}</span>
//                   </div>
//                 ))}
//               </div>

//               <div className="banner-actions">
//                 <button className="shop-now-btn1" onClick={handleShopNow}>
//                   <span>{primaryButtonText}</span>
//                   <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
//                     <path d="M5 12h14l-7-7v14z" />
//                   </svg>
//                 </button>

//                 <button className="explore-btn">
//                   <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
//                     <path d="M8 5v14l11-7z" />
//                   </svg>
//                   <span>{secondaryButtonText}</span>
//                 </button>
//               </div>
//             </div>

//             {/* Right Content - Image */}
//             <div className={`banner-image ${isVisible ? 'animate-in' : ''}`}>
//               <div className="image-container">
//                 <img
//                   src={imageUrl}
//                   alt="Electronics and IoT Components"
//                   className="banner-img"
//                   onError={(e) => {
//                     e.target.src = '/images/banner.png';
//                   }}
//                 />
//                 <div className="image-overlay">
//                   {floatingCards.map((card, index) => (
//                     <div className={`floating-card card-${index + 1}`} key={index}>
//                       <div className="card-icon">{card.icon}</div>
//                       <div className="card-text">{card.text}</div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Banner Navigation Controls */}
//           {banners.length > 1 && (
//             <div className="banner-navigation">
//               <button className="nav-arrow prev-arrow" onClick={goToPrevBanner} aria-label="Previous banner">
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
//                   <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
//                 </svg>
//               </button>

//               <div className="banner-dots">
//                 {banners.map((_, index) => (
//                   <button
//                     key={index}
//                     className={`banner-dot ${index === currentBannerIndex ? 'active' : ''}`}
//                     onClick={() => goToBanner(index)}
//                     aria-label={`Go to banner ${index + 1}`}
//                   />
//                 ))}
//               </div>

//               <button className="nav-arrow next-arrow" onClick={goToNextBanner} aria-label="Next banner">
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
//                   <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
//                 </svg>
//               </button>
//             </div>
//           )}

//           {/* Decorative elements */}
//           <div className="bg-decoration decoration-1"></div>
//           <div className="bg-decoration decoration-2"></div>
//         </div>
//       </section>

//       <div className="hub-navigation">
//         <button className="hub-nav-button components-hub" onClick={handleComponentsHub}>
//           <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
//             <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-5-9h10v2H7z" />
//           </svg>
//           <span>Components Hub</span>
//         </button>

//         <button className="hub-nav-button design-hub" onClick={handleDesignMakersHub}>
//           <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
//             <path d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm3 8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z" />
//           </svg>
//           <span>Design Makers Hub</span>
//         </button>
//       </div>

//     </>
//   );
// };

// export default Banner;





import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Banner.css';

const SimpleBanner = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const navigate = useNavigate();

  // Banner image path - replace with your actual image path
  const bannerImageUrl = '/images/banner1.jpeg';

  // Single banner image
  const images = [bannerImageUrl];
  const isSingleBanner = images.length === 1;

  // Auto-slide every 5 seconds (only if multiple banners)
  useEffect(() => {
    if (images.length <= 1) return undefined;

    const interval = setInterval(() => {
      goToNextSlide();
    }, 5000);

    return () => clearInterval(interval);
  }, [currentIndex, images.length]);

  const goToNextSlide = () => {
    if (images.length <= 1) return;
    if (!isTransitioning) {
      setIsTransitioning(true);
      setCurrentIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
      setTimeout(() => setIsTransitioning(false), 500);
    }
  };

  const goToPrevSlide = () => {
    if (images.length <= 1) return;
    if (!isTransitioning) {
      setIsTransitioning(true);
      setCurrentIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
      setTimeout(() => setIsTransitioning(false), 500);
    }
  };

  const handleComponentsHub = () => {
    navigate('/products');
  };

  const handleDesignMakersHub = () => {
    navigate('/design-makers-hub');
  };

  const hubButtonStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 20px',
    // backgroundColor: '#fff',
    border: '1px solid #ddd',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '16px',
    transition: 'background-color 0.3s',
    color: '#fff',
    textDecoration: 'none',
  };

  return (
    <>
      {/* Banner Section */}
      <div
        className="banner-slider"
        style={{
          position: 'relative',
          width: '100%',
          minHeight: isSingleBanner ? 'auto' : '300px',
          overflow: 'hidden',
          margin: '0 auto',
        }}
      >
        <div
          className="slides-container"
          style={{
            display: 'flex',
            width: '100%',
            height: '100%',
          }}
        >
          {images.map((image, index) => (
            <div
              key={index}
              className={`slide ${index === currentIndex ? 'active' : ''}`}
              style={{
                position: isSingleBanner ? 'relative' : 'absolute',
                width: '100%',
                height: isSingleBanner ? 'auto' : '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                transform: isSingleBanner ? 'none' : `translateX(${100 * (index - currentIndex)}%)`,
                transition: isSingleBanner ? 'none' : (isTransitioning ? 'transform 0.5s ease-in-out' : 'none'),
              }}
            >
              <img
                src={image}
                alt="LEJU ROBOT AELOS"
                style={{
                  width: '100%',
                  display: 'block',
                  height: isSingleBanner ? 'auto' : '100%',
                  objectFit: 'cover',
                }}
                onError={(e) => {
                  e.target.src = '/images/banner1.png';
                }}
              />
            </div>
          ))}
        </div>

        {images.length > 1 && (
          <>
            {/* Slide Navigation Arrows */}
            <button
              className="prev-button"
              onClick={goToPrevSlide}
              style={{
                position: 'absolute',
                top: '50%',
                left: '20px',
                transform: 'translateY(-50%)',
                zIndex: 10,
                background: 'rgba(0, 0, 0, 0.5)',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                fontSize: '18px',
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              aria-label="Previous slide"
            >
              ❮
            </button>

            <button
              className="next-button"
              onClick={goToNextSlide}
              style={{
                position: 'absolute',
                top: '50%',
                right: '20px',
                transform: 'translateY(-50%)',
                zIndex: 10,
                background: 'rgba(0, 0, 0, 0.5)',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                fontSize: '18px',
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              aria-label="Next slide"
            >
              ❯
            </button>

            {/* Slide Indicators */}
            <div
              className="slide-indicators"
              style={{
                position: 'absolute',
                bottom: '40px',
                left: '50%',
                transform: 'translateX(-50%)',
                display: 'flex',
                gap: '10px',
                zIndex: 10,
              }}
            >
              {images.map((_, index) => (
                <button
                  key={index}
                  className={`indicator ${index === currentIndex ? 'active' : ''}`}
                  onClick={() => {
                    if (!isTransitioning) {
                      setIsTransitioning(true);
                      setCurrentIndex(index);
                      setTimeout(() => setIsTransitioning(false), 500);
                    }
                  }}
                  style={{
                    width: '12px',
                    height: '12px',
                    borderRadius: '50%',
                    border: 'none',
                    cursor: 'pointer',
                    backgroundColor: index === currentIndex ? '#fff' : 'rgba(255, 255, 255, 0.5)',
                  }}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </>
        )}
      </div>

      {/* Hub Navigation Buttons Below Banner */}
      <div
        className="hub-navigation"
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '20px',
          padding: '30px 0',
          width: '100%',
        }}
      >
        <button className="hub-nav-button components-hub" onClick={handleComponentsHub} style={hubButtonStyle}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-5-9h10v2H7z" />
          </svg>
          <span>Components Hub</span>
        </button>

        <button className="hub-nav-button design-hub" onClick={handleDesignMakersHub} style={hubButtonStyle}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm3 8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z" />
          </svg>
          <span>Design Makers Hub</span>
        </button>

        <button className="hub-nav-button demo-projects" onClick={() => navigate('/demo-projects')} style={hubButtonStyle}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z" />
          </svg>
          <span>Electronics Lab Kits</span>
        </button>
      </div>
    </>
  );
};

export default SimpleBanner;
